export const MURAL_ROLL_WIDTH_FEET = 2

export const formatMuralSizeDisplay = (
  template: string | undefined,
  rollCount: number
): string | undefined => {
  if (typeof template !== 'string' || !template) {
    return undefined
  }

  return template
    .replace('$WIDTH', String(rollCount * MURAL_ROLL_WIDTH_FEET))
    .replace('$QUANTITY', String(rollCount))
}
